<template>
  <div>
    <slot name="tableMenu" :checked="checkedRows"></slot>
    <!-- if we want to use checkbox per line, will use it.
      :checked-rows.sync="checkedRows"
      checkable -->
    <b-table :data="filteredData"
      :per-page="perPage"
      sortable
      paginated
      pagination-simple
      hoverable
      default-sort-direction="desc"
      default-sort="update_date"
      style="padding-top: 16px;">

      <template slot-scope="props">
        <b-table-column field="id" label="ID" sortable>
          {{ props.row.id | short }}
        </b-table-column>

        <b-table-column field="group" label="グループ" sortable>
          <span class="tag is-info" v-if="props.row.id">
            {{ props.row.group }}
          </span>
        </b-table-column>

        <b-table-column field="name" label="表示名" sortable>
          {{ props.row.name }}
        </b-table-column>

        <b-table-column field="org_file" label="ファイル名" sortable>
          <span style="display: flex; align-items: center;">
            <img width="24" src="../../../assets/word.png" v-if="props.row.kind === 'word'" :title="props.row.type"/>
            <img width="24" src="../../../assets/excel.png" v-else-if="props.row.kind === 'excel'" :title="props.row.type"/>
            <span style="margin: 0 5px;">{{ props.row.org_file | cutpath }}</span>
          </span>
        </b-table-column>

        <b-table-column field="update_date" label="最終更新日" sortable centered>
          {{ props.row.update_date | dateFormat}}
        </b-table-column>

        <b-table-column field="action" label="操作" width="85">
          <div style="display: flex; justify-content: space-between;">
            <update-button v-if="props.row.id"
              class="actionIcon"
              radius
              size="is-small"
              @click="handleOnEditRow(props.row)" />
            <delete-button  v-if="props.row.id"
              class="actionIcon"
              radius
              size="is-small"
              @click="handleOnDelete(props.row)"/>
            </div>
        </b-table-column>
      </template>

      <template slot="empty">
        <b-message type="is-info" has-icon >
          条件に合致するレポートはありません。レポートをまだ登録していない場合は右上の「新規登録」から追加してください。
        </b-message>
      </template>
      
    </b-table>
  </div>
</template>

<script >
import Vue from "vue";
import UpdateButton from "@/components/molecules/Buttons/UpdateButton.vue";
import DeleteButton from "@/components/molecules/Buttons/DeleteButton.vue";
// import moment from "moment";
import moment from "moment-timezone";

export default Vue.extend({
  components: { UpdateButton, DeleteButton },
  data() {
    return {
      checkedRows: [],
      current: 1,
      rows: [], // 表示しているテンプレート(perPage分)
      filteredData: [], // 検索条件に合致している全データ
    };
  },
  props: {
    // 全データ
    data: {
      type: Array,
      default: () => [],
    },
    columns: Array,
    perPage: {
      type: Number,
      default: 10,
    },
    condition: {
      type: Object,
      default: () => {
        return { group: "すべて", keyword: "" };
      },
    },
  },
  mounted() {
    this.showItems();
  },
  watch: {
    data() {
      this.checkedRows = [];
      this.showItems();
    },
    condition() {
      this.checkedRows = [];
      this.showItems();
    },
  },
  methods: {
    showItems(nextPage = 1) {
      // 最初に条件に合うものだけにする
      this.filterItems();

      const startIdx = (nextPage - 1) * this.perPage;
      this.rows = this.filteredData.slice(startIdx, startIdx + this.perPage);
    },
    filterItems() {
      this.filteredData = this.data;
      const { group, keyword } = this.$props.condition;

      // filter by group
      if (group && group !== "すべて") {
        this.filteredData = this.filteredData.filter((i) => i.group === group);
      }

      // filter by keyword
      if (keyword) {
        this.filteredData = this.filteredData.filter((i) => {
          const isInName = i.name.indexOf(keyword) > -1;
          const isInFileName = i.file.indexOf(keyword) > -1;
          return isInName || isInFileName;
        });
      }
    },
    handleOnPaginationChange(nextPage) {
      this.showItems(nextPage);
    },
    handleOnEditRow(item) {
      console.log(item);
      this.$emit("updateItem", item);
    },
    handleOnDelete(item) {
      console.log(item);
      this.$emit("deleteItem", [item]);
    },
  },
  filters: {
    cutpath(value) {
      if (!value) {
        return;
      }
      const splittedVal = value.split("/");
      return splittedVal[splittedVal.length - 1];
    },
    short(value) {
      return value.slice(0, 8);
    },
    dateFormat(value) {
      if (!value) {
        return "";
      }
      return moment.utc(value).tz("Asia/Tokyo").format("YYYY/MM/DD hh:mm:ss");
    },
  },
});
</script>

<style lang="scss" scoped>
.actionIcon {
  width: 27px;
  height: 27px;
}
</style>